import React from "react";
import Navbar from "../../components/common/Navbar";
import BannerSection from "../../components/common/BannerSection";
import ContactBanner from "../../assets/images/banner.jpg";
import ingots from "../../assets/images/ingotse.jpg";
import notchbar from "../../assets/images/notchbar.jpg";
import scrap from "../../assets/images/scrap.jpg";
import cubes from "../../assets/images/cubes.jpg";
import Footer from "../../components/common/Footer";
import Cta from "../../components/common/Cta";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet";
import { config } from "../config";
import { Link } from "react-router-dom";

const Product = () => {
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref4, inView4] = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <div>
      <Helmet>
        <title>Crafting Digital Experiences, Empowering Your Vision</title>
      </Helmet>
      <Navbar inner={true} />
      <BannerSection
        Banner={ContactBanner}
        title={"Product"}
        subtitle={"Our Products"}
      />
      <div className="site-content">
        <div className="about-area ptb-80">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-lg-12 col-md-12">
                <div
                  className={`service-animate ${inView1 ? "visible" : ""
                    }`}
                  ref={ref1}
                >
                  <div className="how-work">
                    <h2>How Does It Work </h2>
                    <p>
                      At Roliox Alloys, we manufacture premium-grade aluminum products using advanced recycling and melting processes. Our products are designed for industrial applications requiring strength, purity, and consistency.
                    </p></div>
                  <div class="cards">

                    <div class="card">
                      <img src={ingots} alt="Shipping" />
                      <h3>ALUMINIUM INGOTS</h3>
                      <p>
                        We produce high-quality aluminum ingots with controlled composition, ideal for casting, extrusion, and manufacturing industries.
                      </p>
                       <Link to={`${config.appUrl}product/aluminium-ingots`} class="btn btn-primary">View More</Link>
                    </div>

                    <div class="card">
                      <img src={cubes} alt="Box" />
                      <h3>ALUMINIUM CUBES</h3>
                      <p>
                        Our aluminum cubes are processed for easy handling, uniform melting, and efficient industrial use.
                      </p>
                       <Link to={`${config.appUrl}product/aluminium-cubes`} class="btn btn-primary">View More</Link>

                    </div>

                    <div class="card">
                      <img src={notchbar} alt="Shopping" />
                      <h3>ALUMINIUM NOTCHBAR</h3>
                      <p>
                        Precision-manufactured aluminum notch bars suitable for various metallurgical and industrial applications.
                      </p>
                       <Link to={`${config.appUrl}product/aluminium-notchbar`} class="btn btn-primary">View More</Link>

                    </div>
                    <div class="card">
                      <img src={scrap} alt="Shopping" />
                      <h3>ALUMINUM SCRAP PURCHASING</h3>
                      <p>
                        We actively purchase all types of aluminum scrap, ensuring competitive pricing and fast processing.
                      </p>
                       <Link to={`${config.appUrl}product/aluminium-scrap-purchasing`} class="btn btn-primary">View More</Link>

                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Cta />
    </div>
  );
};

export default Product;
